import { NextSeo } from "next-seo";
import { Container } from "theme-ui";
import { Themed } from "@theme-ui/mdx";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import PostList from "../../components/PostList";
import useNews from "../../utils/useNews";

const News = () => {
  const { status, news } = useNews();
  return (
    <>
      <NextSeo title="Treats Children Charity Derby | News" />
      <Container variant="page">
        <Header />
        <main>
          <Container>
            <Themed.h1 sx={{ textAlign: "center", m: 0 }}>News</Themed.h1>
          </Container>
          <Container variant="muted">
            <PostList
              posts={news}
              collection="news"
              loading={status === "loading"}
            />
          </Container>
        </main>
      </Container>
      <Footer />
    </>
  );
};

export default News;
